import {Component, EventEmitter, Input, Output, ViewEncapsulation} from '@angular/core';
import {makeReadable} from "../../common/readable.pipe";
import {MAT_CHECKBOX_DEFAULT_OPTIONS, MatCheckboxDefaultOptions} from "@angular/material/checkbox";

@Component({
  selector: 'app-check-box-filter',
  templateUrl: './check-box-filter.component.html',
  styleUrls: ['./check-box-filter.component.sass'],
  encapsulation: ViewEncapsulation.None,
  providers: [
    {provide: MAT_CHECKBOX_DEFAULT_OPTIONS, useValue: {clickAction: 'check'} as MatCheckboxDefaultOptions},
  ],
})
export class CheckBoxFilterComponent {
  @Input() options!: CheckBoxOption[];
  @Input() selected!: string[];
  @Input() user: boolean = false;
  @Input() columns: number = 1;
  @Output() change = new EventEmitter<string[]>();

  checkboxChanged(option: string) {
    if (this.selected.includes(option)) {
      this.selected = this.selected.filter(s => s !== option);
    } else {
      this.selected = [...this.selected, option];
    }
    this.emit();
  }

  clear() {
    this.selected = [];
    this.emit();
  }

  private emit() {
    this.change.emit(this.selected);
  }
}

export interface CheckBoxFilter {
  key: string;
  display: string;
  remember: boolean;
  options: CheckBoxOption[];
  selected: string[];
}

export interface CheckBoxOption {
  display: string;
  value: string;
}

export function option(value: string): CheckBoxOption {
  return {
    display: makeReadable(value),
    value
  };
}
